module.exports = __webpack_public_path__ + "static/img/img_08.da1d352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/113/img_08.jpg
// module id = wkc+
// module chunks = 1